<template>
  <div class="withdraw_modal">
    <div>
      <h1 v-html="$t('global.modalTitle')" />
      <p v-html="$t('global.modalDesc')" />
    </div>
    <div class="method_button">
      <button @click="handleSelectMethod('cash')" :class="{ active: cashWithdraw }">
        <img src="@/assets/images/img_money.svg" alt="cash" />
        <p>{{ $t('global.cash') }}</p>
      </button>
      <button @click="handleSelectMethod('njPoint')" :class="{ active: njPointWithdraw }">
        <img src="@/assets/images/img_nexon_point.svg" alt="point" />
        <p>{{ $t('global.nexonPoint') }}</p>
      </button>
    </div>
    <v-button
      @handleClick="handleClickNext"
      class="btn01"
      :text="$t('common.next')"
      :disabled="(!cashWithdraw && !njPointWithdraw) || isChecking"
    />
  </div>
</template>

<script>
import VButton from '@/components/atoms/VButton';
import { mapActions, mapGetters } from 'vuex';
import { validateGlobalWithdraw } from '@/utils/globalWithdrawValidation';

export default {
  components: {
    VButton,
  },
  data() {
    return {
      cashWithdraw: false,
      njPointWithdraw: false,
      isChecking: false,
    };
  },
  computed: {
    ...mapGetters('point', ['pointInfo']),
    ...mapGetters('exchange', ['exchangeCurrency']),
  },
  methods: {
    ...mapActions('modal', ['closeModal', 'closeDataModal']),
    ...mapActions('exchange', ['getExchangeInfo', 'setIsNjPointWithdraw', 'checkGlobalExchange']),
    handleSelectMethod(type) {
      if (type === 'cash') {
        this.cashWithdraw = true;
        this.njPointWithdraw = false;
        this.setIsNjPointWithdraw(false);
      } else if (type === 'njPoint') {
        this.cashWithdraw = false;
        this.njPointWithdraw = true;
        this.setIsNjPointWithdraw(true);
      }
    },
    async handleClickNext() {
      // 출금 유형이 njPoint인 경우, njPoint 출금 정보를 다시 세팅해야함
      if (this.njPointWithdraw) {
        await this.getExchangeInfo(true);
      }

      this.isChecking = true;
      // 출금 유형에 따른 validation 체크
      const { code } = await this.checkGlobalExchange(this.njPointWithdraw);

      if (code !== 0) {
        this.closeDataModal();
        const { unit } = this.pointInfo;
        const { exchangeMinAmount, exchangeMaxAmount } = this.exchangeCurrency;
        validateGlobalWithdraw({ code, unit, exchangeMinAmount, exchangeMaxAmount });
        this.isChecking = false;
        return;
      }

      this.closeModal();
      this.isChecking = false;
      this.$router.push({
        name: 'GlobalWithdrawForm',
        query: {
          ...this.$route.query,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.withdraw_modal {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 42px;
  padding: 102px 40px 40px;
}

h1 {
  margin-bottom: 8px;
  font-family: 'NEXONLv1Gothic';
  color: #333;
  text-align: center;
  font-size: 24px;
  font-weight: 700;
  line-height: 32px;
}

p {
  color: #333;
  text-align: center;
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
}

.method_button {
  width: 100%;
  display: flex;
  justify-content: center;
  gap: 16px;
  > button {
    width: 100%;
    height: 172px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 18px;
    align-items: center;
    border: 1px solid #efefef;
    background: #f8f9fa;
    font-family: 'Noto Sans JP', 'Malgun Gothic';

    &.active {
      border: 1px solid #0a74ff;
      background: rgba(10, 116, 255, 0.08);
    }
  }
}

@media all and (max-width: 767px) {
  .withdraw_modal {
    gap: 40px;
    padding: 120px 33px 33px;
  }
}

@media all and (max-width: 479px) {
  .withdraw_modal {
    gap: 40px;
    padding: 120px 15px 15px;
    .btn {
      width: 100%;
    }
    ::v-deep span {
      display: block;
    }
  }
}
</style>
